
import {defineComponent, PropType} from "vue";
import CronometroVue from "@/components/CronometroVue.vue";
import BoxVue from '@/components/Box.vue'
import ITarefa from "@/interfaces/ITarefa";

export default defineComponent({
  name: 'TarefaVue',
  props: {
    tarefa: {
      type: Object as PropType<ITarefa>,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  components: {
    CronometroVue,
    BoxVue,
  }
});
